<template>
  <sl-card
    ref="card"
    v-bind="$attrs"
    v-on="$listeners"
    class="instance-card"
    @click.native="goToInstance"
  >
    <v-tooltip v-if="showMasterTitle" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-card-subtitle class="text-truncate pb-0" v-bind="attrs" v-on="on">
          {{ instance.clMaster.title }}
        </v-card-subtitle>
      </template>
      <span>{{ instance.clMaster.title }}</span>
    </v-tooltip>

    <v-card-title :class="{ 'pt-1': showMasterTitle }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <span class="d-inline-block text-truncate" v-bind="attrs" v-on="on">
            {{ instance.title }}
          </span>
        </template>
        <span>{{ instance.title }}</span>
      </v-tooltip>

      <sl-avatar
        v-for="(user, userIndex) in instance.currentlyOnUsers"
        :key="user.id"
        :user="user"
        :style="avatarPositioning(userIndex)"
      ></sl-avatar>
      <!-- <sl-avatar
        v-if="instance.userOnLast"
        :user="instance.userOnLast"
        class="avatar-positioning ma-1"
      ></sl-avatar> -->
    </v-card-title>

    <!-- cardWidth: {{ cardWidth }} -->

    <v-card-text>
      <sl-metadata objectType="instance" :object="instance" />
    </v-card-text>
  </sl-card>
</template>

<script>
import SlAvatar from '@/components/SlAvatar'
import SlMetadata from '@/components/SlMetadata'
import SlCard from '@/components/SlCard'

// import Logger from '@/lib/Logger'

export default {
  props: {
    instance: {
      type: Object,
      required: true,
    },
    showMasterTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  components: {
    SlAvatar,
    SlMetadata,
    SlCard,
  },

  data: () => ({
    cardWidth: 0,
  }),

  computed: {
    //
  },

  mounted() {
    this.cardWidthUpdate()
    window.addEventListener('resize', this.cardWidthUpdate)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.cardWidthUpdate)
  },

  methods: {
    //
    /* onClick() {
      Logger.debug('Doing something!')
    }, */
    goToInstance() {
      this.$router.push({ path: '/checklist/' + this.instance.id })
    },
    cardWidthUpdate() {
      this.cardWidth = this.$refs.card?.$el.clientWidth
    },
    avatarPositioning(index) {
      const offsetMax = 16
      const widthEach = (this.cardWidth * 0.5) / this.instance.currentlyOnUsers.length
      // Logger.debug('widthEach:', widthEach)
      const offset = Math.min(widthEach, offsetMax)
      return `position: absolute; top: 4px; right: ${index * offset}px;`
    },
  },
}
</script>

<style scoped>
/* .avatar-positioning {
  position: absolute;
  top: 0;
  right: 0;
} */
.instance-card {
  border-color: var(--v-instance-base) !important;
}
</style>
